import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5bf86e3e&scoped=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"
import style0 from "./default.vue?vue&type=style&index=0&id=5bf86e3e&prod&lang=less"
import style1 from "./default.vue?vue&type=style&index=1&id=5bf86e3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf86e3e",
  null
  
)

export default component.exports